function buildAvatarSvg({ background, accent, label, pattern }) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <defs>
        <linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="${background}" />
          <stop offset="100%" stop-color="${accent}" />
        </linearGradient>
      </defs>
      <rect width="120" height="120" rx="32" fill="url(#g)" />
      <circle cx="92" cy="28" r="14" fill="rgba(255,255,255,0.2)" />
      <path d="${pattern}" fill="rgba(255,255,255,0.16)" />
      <circle cx="60" cy="48" r="20" fill="rgba(255,255,255,0.22)" />
      <path d="M30 98c4-16 18-26 30-26s26 10 30 26" fill="rgba(255,255,255,0.22)" />
      <text x="60" y="66" text-anchor="middle" font-size="24" font-family="Arial, sans-serif" font-weight="700" fill="#ffffff">${label}</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

function createAvatar({
  id,
  name,
  type,
  unlock_condition,
  unlockedByDefault = false,
  badgeId = null,
  label,
  background,
  accent,
  pattern,
}) {
  return {
    id,
    name,
    type,
    unlock_condition,
    unlockedByDefault,
    badgeId,
    image: buildAvatarSvg({ background, accent, label, pattern }),
  };
}

export const BADGE_CATALOG = [
  {
    id: "badge-challenger",
    name: "Challenger",
    description: "Debloque apres 5 fois premier du classement.",
    color: "bg-amber-100 text-amber-700 border-amber-200",
  },
];

export const AVATAR_CATALOG = [
  createAvatar({
    id: "free-pixy",
    name: "Pixy Starter",
    type: "free",
    unlock_condition: "Disponible par defaut",
    unlockedByDefault: true,
    label: "P",
    background: "#fb7185",
    accent: "#f97316",
    pattern: "M4 82c18-18 36-26 54-24s36 8 58 30v28H4Z",
  }),
  createAvatar({
    id: "free-comet",
    name: "Comet",
    type: "free",
    unlock_condition: "Disponible par defaut",
    unlockedByDefault: true,
    label: "C",
    background: "#38bdf8",
    accent: "#0f172a",
    pattern: "M-10 24c22-10 44-10 66 0s44 10 74 0v22c-30 12-54 12-74 4S16 40-10 52Z",
  }),
  createAvatar({
    id: "free-mint",
    name: "Mint Flash",
    type: "free",
    unlock_condition: "Disponible par defaut",
    unlockedByDefault: true,
    label: "M",
    background: "#10b981",
    accent: "#14b8a6",
    pattern: "M0 100c18-12 34-18 52-18s38 6 68 26v12H0Z",
  }),
  createAvatar({
    id: "badge-challenger",
    name: "Challenger",
    type: "badge",
    unlock_condition: "5 fois premier du classement",
    badgeId: "badge-challenger",
    label: "1",
    background: "#f59e0b",
    accent: "#ef4444",
    pattern: "M10 96 40 50 58 70 84 28 110 96 88 96 58 56 34 96Z",
  }),
  createAvatar({
    id: "event-world-cup",
    name: "Coupe du monde",
    type: "event",
    unlock_condition: "Reserve aux evenements Coupe du monde",
    label: "W",
    background: "#22c55e",
    accent: "#16a34a",
    pattern: "M0 28c16 10 28 14 46 10s30-16 44-16 18 8 30 12v34c-18-8-28-10-42-4S30 70 0 84Z",
  }),
  createAvatar({
    id: "event-olympics",
    name: "Jeux olympiques",
    type: "event",
    unlock_condition: "Reserve aux evenements Jeux olympiques",
    label: "O",
    background: "#2563eb",
    accent: "#9333ea",
    pattern: "M-4 90c26-22 44-34 62-34s34 12 62 34v18H-4Z",
  }),
  createAvatar({
    id: "event-summer",
    name: "Summer vibes",
    type: "event",
    unlock_condition: "Reserve aux evenements d'ete",
    label: "S",
    background: "#f97316",
    accent: "#ec4899",
    pattern: "M0 96c18-10 30-16 44-16s24 2 34 8 20 8 42 8v24H0Z",
  }),
  createAvatar({
    id: "premium-neon",
    name: "Neon Legend",
    type: "premium",
    unlock_condition: "Disponible pendant le lancement",
    unlockedByDefault: true,
    label: "N",
    background: "#0f172a",
    accent: "#06b6d4",
    pattern: "M8 18h104v18H8Zm18 26h68v10H26Zm-8 18h84v34H18Z",
  }),
  createAvatar({
    id: "premium-royal",
    name: "Royal Pulse",
    type: "premium",
    unlock_condition: "Disponible pendant le lancement",
    unlockedByDefault: true,
    label: "R",
    background: "#7c3aed",
    accent: "#f59e0b",
    pattern: "M10 100c14-28 28-42 50-42s36 14 50 42v20H10Z",
  }),
];

export const FREE_AVATAR_IDS = AVATAR_CATALOG.filter(
  (avatar) => avatar.unlockedByDefault
).map((avatar) => avatar.id);

export const AVATAR_UNLOCK_RULES = [
  {
    avatarId: "badge-challenger",
    badgeId: "badge-challenger",
    title: "Challenger",
    description: "5 fois premier du classement",
    isUnlocked: (stats) => (stats.firstPlaceFinishes || 0) >= 5,
    progressLabel: (stats) =>
      `${Math.min(stats.firstPlaceFinishes || 0, 5)}/5 podiums #1`,
  },
];

export function getAvatarById(avatarId) {
  return AVATAR_CATALOG.find((avatar) => avatar.id === avatarId) || null;
}

export function getBadgeById(badgeId) {
  return BADGE_CATALOG.find((badge) => badge.id === badgeId) || null;
}

export function getFallbackAvatarId(seed = "") {
  const source = String(seed || "pixy");
  const base = FREE_AVATAR_IDS.length || 1;
  const hash = [...source].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return FREE_AVATAR_IDS[hash % base] || FREE_AVATAR_IDS[0];
}
